exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".version[data-v-47323bf2]{position:absolute;bottom:0}", "", {"version":3,"sources":["/app/src/components/src/components/index.vue"],"names":[],"mappings":"AAoBA,0BACA,kBAAA,AACA,QAAA,CACA","file":"index.vue","sourcesContent":["<template>\n    <div>\n        <p class=\"version\">v1.0.0.0818.0</p>\n    </div>\n</template>\n\n<script>\nexport default {\n  name: 'index',\n  data () {\n    return {\n    }\n  },\n  mounted(){\n\n  }\n}\n</script>\n\n<style scoped>\n.version{\n    position: absolute;\n    bottom: 0;\n}\n</style>"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47323bf2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index.vue
// module id = tiLD
// module chunks = 1